<template>
    <v-row>
        <!-- Prenom -->
        <v-col cols="12" md="6">
            <v-text-field
                density="compact"
                variant="outlined"
                clearable
                label="Prenom"
                v-model="fields.prenom"
                :error-messages="errors.prenom"
            />
        </v-col>

        <!-- Nom -->
        <v-col cols="12" md="6">
            <v-text-field
                density="compact"
                variant="outlined"
                clearable
                label="Nom"
                v-model="fields.nom"
                :error-messages="errors.nom"
            />
        </v-col>

        <!-- Matricule -->
        <v-col cols="12" md="6">
            <v-text-field
                density="compact"
                variant="outlined"
                clearable
                label="Matricule"
                :disabled="edit"
                v-model="fields.matricule"
                :error-messages="errors.matricule"
            />
        </v-col>

        <!-- Email -->
        <v-col cols="12" md="6">
            <v-text-field
                density="compact"
                variant="outlined"
                clearable
                label="Email"
                v-model="fields.email"
                :disabled="edit"
                :error-messages="errors.email"
            />
        </v-col>

        <!-- Structure -->
        <v-col cols="12" md="6">
            <v-combobox
                density="compact"
                variant="outlined"
                clearable
                persistent-hint
                label="Structure"
                v-model="fields.etablissement"
                item-title="nom"
                :items="etablissements"
                :error-messages="errors.etablissement"
            ></v-combobox>
        </v-col>

        <!-- Profile -->
        <v-col cols="12" md="6">
            <v-select
                density="compact"
                variant="outlined"
                :items="roles"
                label="Profile"
                v-model="fields.role"
                :error-messages="errors.role"
            />
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'UserFields',
    props: {
        fields: { type: Object },
        errors: { type: Object },
        edit: { type: Boolean, default: false },
        isLoading: { type: Boolean, required: true }
    },
    emits: ['load'],
    data() {
        return {
            roles: ['SUPERADMIN', 'ADMIN', 'ADMIN_ETABLISSEMENT', 'CSA', 'DAP', 'DAJ', 'EDITION', 'RECTEUR'],
            etablissements: []
        };
    },

    created() {
        this.getEtab();
    },

    /* Fetching */
    methods: {
        getEtab() {
            this.$emit('load', true);
            axios
                .get('/etablissements')
                .then((resp) => {
                    if (resp && resp.data.success) {
                        this.etablissements = resp.data.data;
                    }
                })
                .catch((err) => {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Erreur',
                        text: 'Nous avons rencontrer une erreur.\nVeuillez réessayer plutard'
                    });
                })
                .finally(() => {
                    this.$emit('load', false);
                });
        }
    }
};
</script>
